import React, { useState, useRef, useEffect } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { Image } from "@project-stories/elements/Image/Image";
import "./BlogArticleTile.scss";
import {Button} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Button/Button";
import { Tooltip } from 'react-tooltip'
import { decodeHtmlEntities } from "frontend/js/helpers";

const OrangeDot = ({ size = 8, color = "#F2610D", ...props }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="4.5" cy="4" r="4" fill={color} />
    </svg>
  );

const BlogMascot = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
      <rect width="80" height="80" rx="40" fill="url(#paint0_linear_17987_136)"/>
      <path d="M52.3304 33.652C71.0996 18.276 53.3853 4.21207 34.355 11.7025C32.3192 12.5038 26.6779 9.29574 21.4523 12.6755C18.0814 14.8557 19.3933 16.5643 18.0807 18.273C16.7681 19.9816 11.7078 19.881 10.5992 24.3177C9.94268 26.9462 11.7596 29.6994 11.5165 31.6779C11.2735 33.6563 9.35499 35.4396 9.26349 38.0513C9.22388 39.1545 9.40196 40.2546 9.78758 41.2888C10.1732 42.3231 10.7588 43.2713 11.5109 44.0792C12.263 44.8872 13.1669 45.539 14.171 45.9975C15.1751 46.4561 16.2597 46.7123 17.3628 46.7516C17.3718 48.9324 18.2233 51.0253 19.7394 52.5929C21.2555 54.1605 23.3187 55.0816 25.498 55.1635C26.9465 55.2143 30.6142 55.2148 33.7659 53.3136C41.6634 48.5508 39.8914 43.8417 52.3304 33.652Z" fill="white"/>
      <path d="M32.841 50.9689C32.841 48.6044 32.7606 36.9414 32.7646 36.7444C26.2729 37.7012 26.4042 25.3531 32.9724 28.3745C34.4174 29.294 38.4896 28.3745 38.0955 20.7554C45.1891 28.3745 53.4248 19.488 54.131 26.7293C55.0955 36.617 54.1252 46.9647 47.9803 46.9655C47.3081 46.9573 46.6379 46.8904 45.9773 46.7653V50.9689C45.9773 53.5962 50.7064 54.9098 50.7064 54.9098C50.7064 54.9098 42.5377 62.6077 39.1464 62.5651C35.7552 62.5225 28.112 54.9098 28.112 54.9098C28.112 54.9098 32.841 53.5962 32.841 50.9689Z" fill="url(#paint1_linear_17987_136)"/>
      <path d="M45.9771 46.7638C42.7177 46.0409 39.6291 44.6938 36.8818 42.7969C36.8818 42.7969 39.1487 48.3385 45.9687 49.39L45.9771 46.7638Z" fill="#DB6F3D"/>
      <path d="M63.5802 62.7914C65.4862 67.0271 66.4701 79.8686 66.4701 79.8686H12.3486C12.3486 79.8686 13.3325 67.0271 15.2386 62.7914C16.9085 59.0809 27.9122 54.8206 31.1369 53.596C32.9989 55.6789 35.6671 57.0114 39.4094 57.0114C43.1517 57.0114 45.8199 55.6789 47.6818 53.596C50.9065 54.8206 61.9103 59.0809 63.5802 62.7914Z" fill="url(#paint2_linear_17987_136)"/>
      <mask id="mask0_17987_136" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="12" y="53" width="55" height="27">
        <path d="M63.5802 62.7914C65.4862 67.0271 66.4701 79.8686 66.4701 79.8686H12.3486C12.3486 79.8686 13.3325 67.0271 15.2386 62.7914C16.9085 59.0809 27.9122 54.8206 31.1369 53.596C32.9989 55.6789 35.6671 57.0114 39.4094 57.0114C43.1517 57.0114 45.8199 55.6789 47.6818 53.596C50.9065 54.8206 61.9103 59.0809 63.5802 62.7914Z" fill="url(#paint3_linear_17987_136)"/>
      </mask>
      <g mask="url(#mask0_17987_136)">
      </g>
      <defs>
        <linearGradient id="paint0_linear_17987_136" x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1D0024"/>
          <stop offset="1" stopColor="#100014"/>
        </linearGradient>
        <linearGradient id="paint1_linear_17987_136" x1="41.2114" y1="20.7554" x2="41.2114" y2="62.5653" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E6864E"/>
          <stop offset="1" stopColor="#EB965E"/>
        </linearGradient>
        <linearGradient id="paint2_linear_17987_136" x1="39.4094" y1="53.596" x2="39.4094" y2="79.8686" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FECBB5"/>
          <stop offset="1" stopColor="#FED4C4"/>
        </linearGradient>
        <linearGradient id="paint3_linear_17987_136" x1="39.4094" y1="53.596" x2="39.4094" y2="79.8686" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FECBB5"/>
          <stop offset="1" stopColor="#FED4C4"/>
        </linearGradient>
      </defs>
    </svg>
);

const LinkedInIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.24268C3.67157 3.24268 3 3.91425 3 4.74268V19.7427C3 20.5711 3.67157 21.2427 4.5 21.2427H19.5C20.3284 21.2427 21 20.5711 21 19.7427V4.74268C21 3.91425 20.3284 3.24268 19.5 3.24268H4.5ZM8.52076 7.2454C8.52639 8.20165 7.81061 8.79087 6.96123 8.78665C6.16107 8.78243 5.46357 8.1454 5.46779 7.24681C5.47201 6.40165 6.13998 5.72243 7.00764 5.74212C7.88795 5.76181 8.52639 6.40728 8.52076 7.2454ZM12.2797 10.0044H9.75971H9.7583V18.5643H12.4217V18.3646C12.4217 17.9847 12.4214 17.6047 12.4211 17.2246C12.4203 16.2108 12.4194 15.1959 12.4246 14.1824C12.426 13.9363 12.4372 13.6804 12.5005 13.4455C12.7381 12.568 13.5271 12.0013 14.4074 12.1406C14.9727 12.2291 15.3467 12.5568 15.5042 13.0898C15.6013 13.423 15.6449 13.7816 15.6491 14.129C15.6605 15.1766 15.6589 16.2242 15.6573 17.2719C15.6567 17.6417 15.6561 18.0117 15.6561 18.3815V18.5629H18.328V18.3576C18.328 17.9056 18.3278 17.4537 18.3275 17.0018C18.327 15.8723 18.3264 14.7428 18.3294 13.6129C18.3308 13.1024 18.276 12.599 18.1508 12.1054C17.9638 11.3713 17.5771 10.7638 16.9485 10.3251C16.5027 10.0129 16.0133 9.81178 15.4663 9.78928C15.404 9.78669 15.3412 9.7833 15.2781 9.77989C14.9984 9.76477 14.7141 9.74941 14.4467 9.80334C13.6817 9.95662 13.0096 10.3068 12.5019 10.9241C12.4429 10.9949 12.3852 11.0668 12.2991 11.1741L12.2797 11.1984V10.0044ZM5.68164 18.5671H8.33242V10.01H5.68164V18.5671Z" fill="black"/>
</svg>
)

const XIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M17.1761 4.24268H19.9362L13.9061 11.0201L21 20.2427H15.4456L11.0951 14.6493L6.11723 20.2427H3.35544L9.80517 12.9935L3 4.24268H8.69545L12.6279 9.3553L17.1761 4.24268ZM16.2073 18.6181H17.7368L7.86441 5.78196H6.2232L16.2073 18.6181Z" fill="black"/>
  </svg>
)





const ActionBar = ({article_url}) => {
    const handleLinkClick = () => {
      navigator.clipboard.writeText(article_url);
      setTooltipOpen(true);
      setTimeout( () => setTooltipOpen(false), 500);
    }

    const [ tooltipOpen, setTooltipOpen ] = useState(false);

    const handleSocialMediaClick = (type) => {
      let shareUrl = "";
      switch(type) {
        case 'x':
          shareUrl = `https://twitter.com/share?url=${encodeURIComponent(article_url)}`;
          break;
        case 'fb':
          shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(article_url)}`;
          break;
        case 'li':
          shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(article_url)}`;
          break;
        default:
          shareUrl = "";
      }
      
      if (shareUrl) {
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
      }
    }
  
    return (
      <div className={'article-tile__actions'}>
          <span className='icon icon-link-alt text-[24px] cursor-pointer'  id="tooltip-anchor" onClick={handleLinkClick}> </span>
          <Tooltip id="article-tile__tooltip"   anchorSelect="#tooltip-anchor" isOpen={tooltipOpen}  data-tooltip-delay-hide={1000} content='Copied To Clipboard'/>
          <span onClick={() => handleSocialMediaClick('li')}><LinkedInIcon /></span>
          <span onClick={() => handleSocialMediaClick('x')}><XIcon /></span>
          {<span className='icon icon-Facebook text-[24px]'  onClick={() => handleSocialMediaClick('fb')}> </span> }
      </div>
    )
  }




function stripHtml(html: string): string {
    if (!html) return "";
    // Remove HTML tags
    return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

function getReadTime(html: string): string {
    const text = stripHtml(html);
    const wordCount = text.split(/\s+/).filter(Boolean).length;
    const mins = Math.floor(wordCount / 200) + 1;
    return `${mins} min read`;
}

function truncateText (text: string, limit: number, excerptExpanded: boolean) {
  if (!text || excerptExpanded) {
    return text;
  }

  const plainText = text.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

  if (plainText.length <= limit) {
    return text;
  }

  const breakPoint = plainText.lastIndexOf(' ', limit);
  const truncateAt = breakPoint > limit * 0.8 ? breakPoint : limit;
  
  const visibleText = plainText.substring(0, truncateAt);
  
  let processedLength = 0;
  let htmlUpToBreak = '';
  
  let inTag = false;
  let currentTag = '';
  
  for (let i = 0; i < text.length && processedLength < visibleText.length; i++) {
    const char = text[i];
    
    if (char === '<') {
      inTag = true;
      currentTag += char;
    } else if (char === '>') {
      inTag = false;
      currentTag += char;
      htmlUpToBreak += currentTag;
      currentTag = '';
    } else if (inTag) {
      currentTag += char;
    } else {
      htmlUpToBreak += char;
      processedLength++;
    }
  }

  return htmlUpToBreak + '...';
};

type BlogArticleTileType = "default" | "pdf" | "stories";

interface BlogArticleTileProps {
  article: any;
  settings: any;
  type?: BlogArticleTileType;
}


export const BlogArticleTile: React.FC<BlogArticleTileProps> = ({
    article,
    settings,
    type = "default"
  }) => {
    const isMobile = useMobileBreakpoint(settings.globals.mobile_breakpoint);
    const { tags, content, excerpt, image } = article;

    const { globals: { article_content_gap, articles_title_style, articles_title_style_mobile, shop_url } } = settings;
    const [excerptExpanded, setExcerptExpanded] = useState(false);
    const [hasOverflow, setHasOverflow] = useState(false);;

    const isMediaTile = type === "stories" && article?.metafields?.featured_media?.url;
    const characterLimit = isMediaTile ?  isMobile ? 150 : 570 : 200;
    
    useEffect(() => {
      const  contentLength =  content ?  content.length : 0;
    
      const shouldShowButton = contentLength > characterLimit;
      setHasOverflow(shouldShowButton);
    }, [content, isMobile]);



    const getArticleUrl = () => {
        let articleUrl = `/blogs/${article.handle}`;
        if (article.blog?.handle && !article.handle.includes(article.blog.handle)) {
            articleUrl = `/blogs/${article.blog.handle}/${article.handle}`;
        } else if (settings?.blog?.handle && !article.handle.includes(settings.blog.handle)) {
            articleUrl = `/blogs/${settings.blog.handle}/${article.handle}`;
        }
        return articleUrl;
    };

    const article_url = getArticleUrl();

    const readTime =
    article?.metafields?.read_time ||
    (content ? getReadTime(content) : "1 min read");

    const pdfURL = article?.metafields?.pdf;

    const articleCategories = tags  && tags.slice(0, 2);
    const showMetadata = readTime || (tags  && tags > 0);
 
    if (type === "stories") {
      const { metafields: { person_name, article_location, featured_quote, featured_media, featured_link } } = article;

      if (isMobile) {
        return (
          <div className="article-tile article-tile--stories flex flex-col">
            <div className="article-tile__header flex flex-col justify-start items-start">
              { image && <div className="mb-2"> <Image imageUrl={image} classes="rounded-full w-[80px] h-[80px] object-cover"/> </div> }
              <div className="article-tile__header-content flex flex-col items-start gap-0">
                <Paragraph
                  text={person_name}
                  type={`article-tile__title h5`}
                />
                <Paragraph
                  text={article_location}
                  type={`article-tile__title b3 text-[#AAA]`}
                />
                <div className="article-tile__tag b5--bold mt-2">{tags && tags[0]}</div>

              </div>

            </div>

                { isMediaTile  &&  <div className="justify-center mx-auto">
                  <ActionBar article_url={`${shop_url}${article_url}`} />
                </div> }
       
               {isMediaTile && 
                    <div className="my-3">
                      <div className="w-full h-[240px]">
                            { featured_media?.type === 'video' ?          
                      <div className={`h-full w-full rounded-[32px]`}>
                        <video
                            id={`video-${person_name}`}
                            key={`video-${person_name}`}
                            controls={true}
                            className="object-cover h-full w-full rounded-[32px]"
                            preload="metadata"
                            playsInline
                            poster={featured_media?.preview_image || undefined}
                          >
                          <source src={featured_media?.url} type="video/mp4"/>
                        </video>
                      </div>   
                        :
                        <Image
                            imageUrl={featured_media?.url}
                            classes={`article-tile__featured-image`}
                        /> }
                </div>    
              </div>}
              {isMediaTile && 
            <div className="article-tile__quote">
              <Paragraph
                text={featured_quote}
                type={`b4 italic text-center`}
              />
            </div> }
            <div className="article-tile__content mb-4">
              <div className="article-tile__excerpt-wrapper">
                {React.createElement(
                  'div',
                  {
                    className: `b4 article-tile__excerpt ${isMediaTile ? '' : `no-media ${!excerptExpanded ? 'max-h-[64px]' : ''}`}`,
                    dangerouslySetInnerHTML: {
                      __html: decodeHtmlEntities(truncateText(content, characterLimit, excerptExpanded)),
                    }
                  }
                )}
              </div>
            </div>
            <div className="article-tile__buttons flex flex-col gap-4">
              {hasOverflow && (
                <Button
                  label={excerptExpanded ? 'Read Less' : 'Read More'}
                  style="secondary"
                  className="w-full"
                  link={undefined}
                  onClick={() => setExcerptExpanded(!excerptExpanded)}
                />
              )}
              {isMediaTile && featured_link && (
                <Button
                  label={'Shop Now'}
                  style="primary"
                  className="w-full"
                  link={featured_link}
                />
              )}
            </div>
          </div>
        );
      }
      return (
        <div className="article-tile article-tile--stories">
          <div className={`${isMediaTile  ? 'w-[calc(41%-16px)]' : ''}`}>
            <div className="article-tile__header  ">
              { image &&  <Image imageUrl={image} classes="rounded-full w-[80px] h-[80px] object-cover"/>  }
              <div className="article-tile__header-content">
                <div className="mb-2 flex-col flex lg:h-[47px]" >
                  <Paragraph
                    text={person_name}
                    type={`article-tile__title h5`}
                  />
                  <Paragraph
                    text={article_location}
                    type={`article-tile__title b3 text-[#AAA]`}
                  />
                </div>
                <div className="article-tile__tag b5--bold"> {tags && tags[0]}</div>
               { isMediaTile  &&  <div className="mt-5"> <ActionBar article_url={`${shop_url}${article_url}`} /> </div> }
              </div>
            </div>
            <div className="article-tile__quote">
              <Paragraph
                text={featured_quote}
                type={`b4 italic text-center`}
              />
            </div>
            <div className="article-tile__content">
              <div className="article-tile__excerpt-wrapper">
                {React.createElement(
                  'div',
                  {
                    className: `b4 article-tile__excerpt ${isMediaTile ? '' : `no-media ${!excerptExpanded ? 'max-h-[64px]' : ''}`} `,
                    dangerouslySetInnerHTML: {
                      __html: decodeHtmlEntities(truncateText(content, characterLimit, excerptExpanded)),
                    }
                  }
                )}
              </div>
            </div>
            <div className="article-tile__buttons">
              {hasOverflow && (
                <Button
                  label={excerptExpanded ? 'Read Less' : 'Read More'}
                  style="secondary"
                  className="w-full"
                  link={undefined}
                  onClick={() => setExcerptExpanded(!excerptExpanded)}
                />
              )}
              {isMediaTile && featured_link && (
                <Button
                  label={'Shop Now'}
                  style="primary"
                  className="w-full pt-4"
                  link={featured_link}
                />
              )}
            </div>
          </div>
          { isMediaTile  &&
          <div className="w-full h-[591px]">
                 { featured_media?.type === 'video' ?          
         <div className={`h-full w-full rounded-[32px]`}>
            <video
                id={`video-${person_name}`}
                key={`video-${person_name}`}
                controls={true}
                className="object-cover h-full w-full rounded-[32px]"
                preload="metadata"
                playsInline
                poster={featured_media?.preview_image || undefined}
              >
              <source src={featured_media?.url} type="video/mp4"/>
            </video>
          </div>   
            :
              <Image
                imageUrl={featured_media?.url}
                classes={`article-tile__featured-image`}
              /> }
          </div>
        }
        </div>
      );
    }

    return (
        <div className="article-tile" style={{ gap: `${article_content_gap}px` }}>
            <a href={article_url} className="article-tile__image-container">
                <Image
                    imageUrl={typeof article?.image === "object" && article?.image?.src ? article?.image?.src : article?.image}
                    classes={`article-tile__image`}
                />
            </a>

            <div className="article-tile__details" style={{ gap: `${article_content_gap}px` }}>
                {showMetadata && !isMobile && type == 'default' &&  (
                    <div className="article-tile__metadata">
                        {readTime && (
                        <span className="article-tile__category b3--bold">{readTime}</span>
                        )}
                        {articleCategories && articleCategories.map((tag, idx) => (
                        <React.Fragment key={`${tag}-${idx}`}>
                            <OrangeDot />
                            <span className="article-tile__category b3--bold">{tag}</span>
                        </React.Fragment>
                        ))}
                    </div>
                )}

                {readTime && isMobile &&  type == 'default' && (
                    <div className="article-tile__metadata">
                        <span className="article-tile__category b3--bold text-rhv-orange mx-auto !leading-[24px]">{readTime}</span>
                    </div>
                )}

                
                <div className="article-tile__text-group">
                    <div className="article-tile__header">
                        <Paragraph
                            text={article.title}
                            type={`article-tile__title ${isMobile ? articles_title_style_mobile : articles_title_style}`}
                        />
                        {isMobile && type == 'default' && ( 
                                 <Button
                                   label={'Read More'}
                                   style="secondary"
                                   className="w-full mt-6"
                                   link={article_url}
                               />
                        )}

                        {type === 'pdf' && pdfURL && (
                        <div className="flex w-full justify-center">
                            <a
                            href={pdfURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-6 w-[200px]"
                            style={{ display: "inline-block" }}
                            >
                            <Button
                                label={'View PDF'}
                                style="secondary"
                                className="w-full"
                                link={undefined}
                      
                            />
                            </a>
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogArticleTile;
